import type { Connection, MedicalTreatment } from "@/lib/types";
import {
  createContactConnectionChildInput,
  getActiveContactConnections,
} from "./item-contact-connections";

export const MEDICAL_TREATMENT_CONTACT_CONNECTION_TYPES = {
  "Lien Holder": "matter_medical_treatment_to_lien_holder",
  "Lien Representative": "matter_medical_treatment_to_lien_representative",
  Provider: "matter_medical_treatment_to_provider",
  "Treating Physician": "matter_medical_treatment_to_treating_physician",
} as const;

export type SupportedMedicalTreatmentContactRole =
  keyof typeof MEDICAL_TREATMENT_CONTACT_CONNECTION_TYPES;

export const getMedicalTreatmentContactConnections = (
  treatment: MedicalTreatment | undefined,
  role: SupportedMedicalTreatmentContactRole,
): Connection[] => {
  const nativeType = MEDICAL_TREATMENT_CONTACT_CONNECTION_TYPES[role];
  const legacyType = nativeType.replace(
    "matter_medical_treatment_to_",
    "matter_medical_treatment_to_legacy_",
  );
  return [nativeType, legacyType].flatMap((connectionType) =>
    getActiveContactConnections(
      treatment,
      "matter_medical_treatment",
      connectionType,
    ),
  );
};

export const getMedicalTreatmentContactConnection = (
  treatment: MedicalTreatment | undefined,
  role: SupportedMedicalTreatmentContactRole,
): Connection | undefined =>
  getMedicalTreatmentContactConnections(treatment, role)[0];

export const createMedicalTreatmentContactConnectionChildInput = (
  contactId: string,
  role: SupportedMedicalTreatmentContactRole,
) =>
  createContactConnectionChildInput(
    contactId,
    MEDICAL_TREATMENT_CONTACT_CONNECTION_TYPES[role],
  );
